//Requirement import of fancybox is moved to main.js, otherwise it wont work

export function gallery() {

    const init = function () {

        $('[data-fancybox]').fancybox({
            zoom:true,
            loop: true,
            closeExisting: true,
            thumbs: {
                autoStart: true,
                axis: "x"
            }
        });
    };

    init();
}